import React from 'react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="compra" className="py-20 px-4 bg-black text-white relative overflow-hidden" data-id="element-174">
      {/* Background accents */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-gradient-to-b from-red-900/20 to-transparent pointer-events-none" data-id="element-175"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-176">
        <div className="text-center mb-10" data-id="element-177">
          <div className="inline-block bg-red-600 text-white font-black px-6 py-2 rounded-full mb-6 text-xl animate-pulse" data-id="element-178">
            ⏰ Oferta por tiempo limitado
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-8" data-id="element-179">
            Accede hoy a:
          </h2>
        </div>

        <div className="bg-gray-900 border-2 border-yellow-500 rounded-2xl p-8 md:p-10 shadow-[0_0_30px_rgba(234,179,8,0.3)] mb-10" data-id="element-180">
          <ul className="space-y-4 text-xl md:text-2xl font-bold mb-10" data-id="element-181">
            <li className="flex items-center" data-id="element-182">
              <span className="text-green-500 mr-4 text-2xl" data-id="element-183">✔</span> Sistema
              completo RESET CORPORAL 30D
            </li>
            <li className="flex items-center" data-id="element-184">
              <span className="text-green-500 mr-4 text-2xl" data-id="element-185">✔</span> 5 Tomos
              estructurados
            </li>
            <li className="flex items-center" data-id="element-186">
              <span className="text-green-500 mr-4 text-2xl" data-id="element-187">✔</span> 3 Bonos
              exclusivos
            </li>
            <li className="flex items-center" data-id="element-188">
              <span className="text-green-500 mr-4 text-2xl" data-id="element-189">✔</span> Acceso
              inmediato
            </li>
            <li className="flex items-center" data-id="element-190">
              <span className="text-green-500 mr-4 text-2xl" data-id="element-191">✔</span> Descarga
              digital
            </li>
            <li className="flex items-center" data-id="element-192">
              <span className="text-green-500 mr-4 text-2xl" data-id="element-193">✔</span> Un solo
              pago
            </li>
          </ul>

          <div className="text-center border-t border-gray-700 pt-8" data-id="element-194">
            <p className="text-2xl text-gray-400 font-medium mb-2" data-id="element-195">
              Precio regular:{' '}
              <span className="line-through decoration-red-500 decoration-4" data-id="element-196">
                $49.990
              </span>
            </p>
            <p className="text-5xl md:text-7xl font-black text-yellow-400 mb-8 drop-shadow-lg" data-id="element-197">
              HOY SOLO: $19.990
            </p>

            <CTAButton text="👉 COMENZAR MI RESET AHORA" isExternal={true} href="https://pagos.fegion.online/cart/45638802243723:1" className="w-full text-2xl md:text-3xl py-7" data-id="element-198" />
          </div>
        </div>
      </div>
    </section>;
}